import { HTTP } from './helpers/http.js'

export default {
  getIdeaMatches(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/ml/search-implement-rev`
    return HTTP.post(url, data)
  },
}
